import type { ReactNode } from "react";

interface FieldRowProps {
  children: ReactNode;
}

/**
 * Side-by-side layout for two (or more) form fields. Stacks on mobile,
 * splits evenly on tablet+ — matches the mockup's pairing of City/State
 * and SIC/Year on desktop.
 */
export function FieldRow({ children }: FieldRowProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{children}</div>;
}
